export var EEventType = /*#__PURE__*/function (EEventType) {
  EEventType["TabChanged"] = "tabChanged";
  EEventType["FlowChanged"] = "flowChanged";
  EEventType["ViewChanged"] = "viewChanged";
  EEventType["EmailChecked"] = "emailChecked";
  EEventType["PhoneChecked"] = "phoneChecked";
  EEventType["AuthenticateSucceed"] = "authenticateSucceed";
  EEventType["RestoreSucceed"] = "restoreSucceed";
  EEventType["RegisterSucceed"] = "registerSucceed";
  EEventType["EmailSentClosed"] = "emailSentClosed";
  /**
   * Социальная авторизация
   */
  EEventType["SocialButtonClick"] = "social.buttonClick";
  EEventType["SocialAuthenticateSucceed"] = "social.authenticateSucceed";
  EEventType["SocialAuthenticateEmailRequired"] = "social.authenticateEmailRequired";
  EEventType["SocialAuthenticateEmailTaken"] = "social.authenticateEmailTaken";
  EEventType["SocialMergeSucceed"] = "social.mergeSucceed";
  EEventType["SocialMergeMergeClick"] = "social.mergeMergeClick";
  /**
   * MR OAuth
   */
  EEventType["MROAuthUnavailable"] = "mrOAuth.unavailable";
  EEventType["MROAuthShown"] = "mrOAuth.shown";
  EEventType["MROAuthClosed"] = "mrOAuth.closed";
  EEventType["MROAuthActionRequired"] = "mrOAuth.actionRequired";
  /**
   * Двухфакторная авторизация
   */
  EEventType["TwoFactorRequired"] = "twoFactorRequired";
  EEventType["TwoFactorInvalid"] = "twoFactorInvalid";
  EEventType["TwoFactorAttemptsExhausted"] = "twoFactorAttemptsExhausted";
  EEventType["TwoFactorWhatForClick"] = "twoFactorWhatForClick";
  EEventType["TwoFactorContinueClick"] = "twoFactorContinueClick";
  EEventType["TwoFactorCannotConfirmClick"] = "twoFactorCannotConfirmClick";
  EEventType["TwoFactorAttemptsExhaustedSupportClick"] = "twoFactorAttemptsExhaustedWriteToSupportClick";
  /**
   * Регистрация
   */
  EEventType["ConfirmPhoneResendClick"] = "confirmPhoneResendClick";
  EEventType["ConfirmPhoneConfirmClick"] = "confirmPhoneConfirmClick";
  EEventType["ConfirmPhoneCancelClick"] = "confirmPhoneCancelClick";
  EEventType["ConfirmPhoneSucceed"] = "confirmPhoneSucceed";
  return EEventType;
}({});